import script from "./AssetProcessingTechniquePropertyAddForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetProcessingTechniquePropertyAddForm.vue?vue&type=script&setup=true&lang=ts"

import "./AssetProcessingTechniquePropertyAddForm.vue?vue&type=style&index=0&id=903a4bea&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-903a4bea"]])

export default __exports__